import _ from 'lodash';
import UserApi from '../resources/userApi';
import AudioApi from '../resources/audioApi';
import PodcastApi from '../resources/podcastApi';
import Auth from '../auth/auth';

const auth = new Auth();

const authHeader = () => {
  if (auth && auth.getAccessToken()) {
    return { Authorization: `Bearer ${auth.getAccessToken()}` };
  }
  return {};
};

const SERVICE_URL = 'http://localhost:3000/';

export class API {
  constructor(authentication = {}, options = {}) {
    const { service_url = SERVICE_URL } = options;

    let mergedHeaders = _.assignIn(authHeader(), {});

    this.userApi = new UserApi(service_url, authentication, mergedHeaders);
    this.audioApi = new AudioApi(service_url, authentication, mergedHeaders);
    this.podcastApi = new PodcastApi(service_url, authentication, mergedHeaders);
  }
}
